
import { useCallback, useState } from 'react'
import { DateBox } from 'devextreme-react';
import { DateBoxTypes } from 'devextreme-react/cjs/date-box';
const edit_cell_time_picker = (params:any) => {
    

    let cval:Date|undefined=undefined;
    if(params.value !=undefined && params.value.indexOf(':')>=0)
    {        
        var hours = params.value.split(':')[0]
        var minutes = params.value.split(':')[1]
        cval = new  Date(1970,1,1,hours,minutes);
    }

    


    const [val] = useState(cval);
    
    const onValueChanged = useCallback((e: DateBoxTypes.ValueChangedEvent) => {  
        
        if(e.value==null)
        {
            params.component.cellValue(params.rowIndex,params.column.caption,null);
        }
        else
        {
            var tval= e.value.getHours().toString().padStart(2,'0') +':' +e.value.getMinutes().toString().padStart(2,'0');
            params.component.cellValue(params.rowIndex,params.column.caption,tval);
        }
             
      }, []);
    return   <DateBox
    defaultValue={val}
    type="time"
    //inputAttr={clearLabel}
    showClearButton={true}
    onValueChanged={onValueChanged}
    />   
  };
  export default edit_cell_time_picker;